// extracted by mini-css-extract-plugin
module.exports = {"place":"_93444fe79c--place--PtHkW","content":"_93444fe79c--content--Ur84u"};